module.exports = __webpack_public_path__ + "media/site/images/charts-13e2b8e8ab764ff1c1edc8b599df3259.svg";